import { createFeatureSelector, createSelector } from '@ngrx/store';
import { IUserMeState, userMeKey } from './user-me.state';
import { IUserMe } from '@app/api/interfaces/user-me.interface';
import { Nullable } from 'primeng/ts-helpers';

export const selectUserMeState = createFeatureSelector<IUserMeState>(userMeKey);

export const selectIsUserMeLoaded = createSelector(
  selectUserMeState,
  (userState: IUserMeState): boolean => userState.loaded
);

export const selectIsUserMeLoading = createSelector(
  selectUserMeState,
  (userState: IUserMeState): boolean => userState.loading
);

export const selectUserMe = createSelector(
  selectUserMeState,
  (userState: IUserMeState): Nullable<IUserMe> => userState.data
);
